import styles from './styles.module.css'

export default function ResultsPaTool({dict}) {
    const {results_pa_tool_1, results_pa_tool_2} = dict.discover;

    return (
        <section className={styles.results_pa_tool}>
            <p>{results_pa_tool_1}</p>
            <p>{results_pa_tool_2}</p>
        </section>
    );
}
